import Component from '../Component';
import $ from '../../vendor/CustomJquery';
import Quill from 'quill/core';
import BaseTheme from 'quill/themes/base';
import Bubble from 'quill/themes/bubble';
import Toolbar from 'quill/modules/toolbar';
import Bold from 'quill/formats/bold';
import Italic from 'quill/formats/italic';
import Underline from 'quill/formats/underline';
import Strike from 'quill/formats/strike';
import Header from 'quill/formats/header';
import List from 'quill/formats/list';
import Link from 'quill/formats/link';

export default class WYSIWYGEditor extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    this.elements = $('.is-wysiwyg-editor');

    this.start();
    return super.initialize();
  }

  start() {
    this.elements.each((index, element) => {
      this.editor( $(element) );
    });
  }

  editor(element) {

    let container = element,
        textarea = container.next('textarea.is-hidden');

    Quill.register({
      'themes/base': BaseTheme,
      'themes/bubble': Bubble,
      'modules/toolbar': Toolbar,
      'formats/header': Header,
      'formats/bold': Bold,
      'formats/italic': Italic,
      'formats/underline': Underline,
      'formats/strike': Strike,
      'formats/list': List,
      'formats/link': Link,
    });

    let editor = new Quill('#' + container.attr('id'), {
        modules: {
          toolbar: [
            [{ 'header': [2, 3, false]}],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['link'],
            ['clean']
          ]
        },
        theme: 'bubble'
    });

    container.find('.ql-editor').addClass('content');

    editor.on('text-change', () => {
      textarea.html(editor.root.innerHTML);
    });

  }

}